import React from "react";
import "./styles.css";
import Card from "./card";
import { Col, Row } from "antd";
import img1 from "../../../../Images/vidGallery/softwareSetup.jpg";
import img2 from "../../../../Images/vidGallery/softwareInstallation.jpg";
import img3 from "../../../../Images/vidGallery/voiceSettings.jpg";
import img4 from "../../../../Images/vidGallery/submittingLead.jpg";
import img5 from "../../../../Images/vidGallery/transferringCall.jpg";
import img6 from "../../../../Images/vidGallery/crm.jpg";
import img7 from "../../../../Images/vidGallery/knack.jpg";

export default class CoursesTab extends React.Component {
  state = {
    titlesArray: [
      "Required Softwares",
      "Software Installation",
      "Setting Up Soundboard",
      "Logging Into CRM",
      "Transferiing A Call",
      "Submitting A Lead",
      "Use Of Knack",
    ],
    urlArray: [
      "https://youtu.be/ZhdME7cK9KM",
      "https://youtu.be/UBqBQdbWt8I",
      "https://youtu.be/Q_AC3wk8zWg",
      "https://youtu.be/xHKBlaHVT0s",
      "https://youtu.be/VA8gFZUQkeY",
      "https://youtu.be/4-R_mAxGvEc",
      "https://youtu.be/ibYc7iPyxTA",
    ],
    thumbnailArray: [img1, img2, img3, img4, img5, img6, img7],
  };

  render() {
    const { titlesArray, urlArray, thumbnailArray } = this.state;
    return (
      <div>
        <div className="centsralDiv">
          <Row>
            <Col span={5}>
              {" "}
              <Card
                title={titlesArray[0]}
                url={urlArray[0]}
                thumbnail={thumbnailArray[0]}
              />
            </Col>
            <Col span={1} />
            <Col span={5}>
              <Card
                title={titlesArray[1]}
                url={urlArray[1]}
                thumbnail={thumbnailArray[1]}
              />
            </Col>
            <Col span={1} />
            <Col span={5}>
              <Card
                title={titlesArray[2]}
                url={urlArray[2]}
                thumbnail={thumbnailArray[2]}
              />
            </Col>
            <Col span={1} />
            <Col span={5}>
              <Card
                title={titlesArray[3]}
                url={urlArray[3]}
                thumbnail={thumbnailArray[3]}
              />
            </Col>
          </Row>
          <br />
          <Row>
            <Col span={5}>
              {" "}
              <Card
                title={titlesArray[4]}
                url={urlArray[4]}
                thumbnail={thumbnailArray[4]}
              />
            </Col>
            <Col span={1} />
            <Col span={5}>
              <Card
                title={titlesArray[5]}
                url={urlArray[5]}
                thumbnail={thumbnailArray[5]}
              />
            </Col>
            <Col span={1} />
            <Col span={5}>
              <Card
                title={titlesArray[6]}
                url={urlArray[6]}
                thumbnail={thumbnailArray[6]}
              />
            </Col>
            <Col span={1} />
          </Row>
          <br />
        </div>
      </div>
    );
  }
}
